import styled from 'styled-components';

export const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 16px;
  justify-content: center;
  background-color: ${({ theme }) => theme.backgroundBaseQuaternary};
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.innerShadowDivider};
`;

export const MenuSearchContainer = styled(MenuItemContainer)`
  div {
    box-sizing: unset;
  }
  align-items: flex-start;
`;

export const MenuSpace = styled.li`
  height: 16px;
`;

export const MenuContainer = styled.div`
  position: absolute;
  top: 61px;
  width: 100%;
  right: 0;
  background: ${({ theme }) => theme.onPrimaryColor};
  list-style-type: none;
  text-align: center;
  z-index: 2;

  &:after {
    content: '';
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    left: 0;
    z-index: 0;
  }
`;

export const MenuItem = styled.li`
  padding: ${({ isRelevant }) => (isRelevant ? '24px' : '16px')} 16px;
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.innerShadowDivider};
  line-height: 150%;
  display: flex;
  justify-content: left;
  background-color: ${({ isRelevant, theme }) =>
    isRelevant ? theme.onPrimaryColor : theme.backgroundBaseSecondary};
  color: ${({ isRelevant, theme }) =>
    isRelevant ? theme.primaryColor : theme.textPrimary};
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;

  a,
  &:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const MenuSearchBarLabel = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: ${({ theme }) => theme.textPrimary};
`;
